var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0.229 0.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10.linkedin",
    "data-name": "10.linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    width: 30,
    height: 30,
    rx: 4,
    transform: "translate(-0.229 -0.229)",
    fill: "#0b63bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5.606 5.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M38.435,35.518A2.518,2.518,0,1,1,35.918,33,2.518,2.518,0,0,1,38.435,35.518Z",
    transform: "translate(-33.4 -33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M40.661,69.9V81.028a.623.623,0,0,1-.623.626H37.384a.623.623,0,0,1-.624-.624V69.9a.624.624,0,0,1,.624-.624h2.654a.624.624,0,0,1,.623.624Z",
    transform: "translate(-36.196 -63.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M82.584,74.78v5.385a.572.572,0,0,1-.574.574H79.156a.572.572,0,0,1-.574-.574V74.946c0-.779.228-3.411-2.036-3.411-1.754,0-2.112,1.8-2.182,2.61v6.019a.574.574,0,0,1-.566.574H71.042a.572.572,0,0,1-.572-.574V68.94a.572.572,0,0,1,.572-.574H73.8a.574.574,0,0,1,.574.574v.97a3.907,3.907,0,0,1,3.676-1.731c4.562,0,4.535,4.26,4.535,6.6Z",
    transform: "translate(-64.248 -62.275)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.af7f15c5377369d2f123db6427dbe19c.svg";
export { ForwardRef as ReactComponent };